/* eslint-disable jsx-a11y/control-has-associated-label */
import './progress.css';

const CircelProgress = () => <div role="progressbar" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100" />;

export default CircelProgress;
